var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-12"},[_c(_setup.MoreFilmsCarousel,{staticClass:"all-films-carousel",attrs:{"portraitMode":true,"title":_setup.i18n.t('components.films.allFilms')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }